import { NO, YES } from '~/common/constants';

export function getBorrowerAgeFromDate(dateOfBirth: string): number {
  const today = new Date();
  const dob = new Date(dateOfBirth);
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age;
}

type BooleanLikeToStrings<T> = [Extract<T, boolean>] extends [never]
  ? T
  : Exclude<T, boolean> | 'Yes' | 'No';

type BooleansToStrings<T> = {
  [K in keyof T]: BooleanLikeToStrings<T[K]>;
};

export function booleansToStrings<T>(obj: T): BooleansToStrings<T> {
  const result: any = {};
  for (const key in obj) {
    if (typeof obj[key] === 'boolean') {
      result[key] = obj[key] ? YES : NO;
    } else {
      result[key] = obj[key];
    }
  }
  return result;
}

export function stringsToBooleans<T>(obj: BooleansToStrings<T>): T {
  const result: any = {};
  for (const key in obj) {
    if (obj[key] === YES) {
      result[key] = true;
    } else if (obj[key] === NO) {
      result[key] = false;
    } else {
      result[key] = obj[key];
    }
  }
  return result;
}
